import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import APIService from '../services/APIService';
import PaddedGrid from '../components/PaddedGrid';
import { Typography, Grid, Table, TableHead, TableBody, TableRow, TableCell, Button, TextField } from '@material-ui/core';
import OrganisationAdder from '../components/OrganisationAdder';
import AppContext from '../AppContext';
import { withTranslation } from 'react-i18next';

class Organisations extends Component {
    constructor(props) {
        super(props);

        this.state = {
            organisations: [],
            search: '',
            showModal: false
        };

        this.handleOrganisationAdded = this.handleOrganisationAdded.bind(this);
    }

    filterBySearch(organisation) {
        return !this.state.search ||
            organisation.name.toLowerCase().includes(this.state.search.toLowerCase());
    }

    handleOrganisationAdded(organisation) {
        let organisations = this.state.organisations;
        organisations.push(organisation);
        organisations.sort((a, b) => a.name > b.name);

        this.setState({
            organisations,
            showModal: false
        });
    }

    componentDidMount() {
        APIService.getOrganisations()
            .then((organisations) => {
                organisations.sort((a, b) => a.name > b.name);
                this.setState({organisations})
            })
            .catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    render() {
        if (!AppContext.isAdmin())
        {
            return (<Redirect to="/"/>)
        }

        return (
            <PaddedGrid>
                <Grid item xs={12}>
                    <Typography variant="title">{this.props.t('Organisaatiot')}</Typography>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="subheading">{this.props.t('Etsi organisaatio')}</Typography>
                    <TextField
                        fullWidth
                        label={this.props.t('Organisaation nimi')}
                        value={this.state.search}
                        onChange={(event) => this.setState({search: event.target.value})}/>
                </Grid>

                <Grid item xs={12}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>{this.props.t('Nimi')}</TableCell>
                                <TableCell>{this.props.t('Käyttäjätunnus')}</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {this.state.organisations.map((organisation, i) => {
                                return this.filterBySearch(organisation) ? (
                                    <TableRow key={i} component={Link} to={{
                                        pathname: `/organisations/${organisation.id}`,
                                        state: {organisation}
                                    }}
                                    style={{textDecoration: 'none'}}
                                    >
                                        <TableCell>{organisation.id}</TableCell>
                                        <TableCell>{organisation.name}</TableCell>
                                        <TableCell>{organisation.user.email}</TableCell>
                                    </TableRow>
                                ) : ''; })}
                        </TableBody>
                    </Table>

                    <OrganisationAdder
                        open={this.state.showModal}
                        onAdded={this.handleOrganisationAdded}
                        onClose={() => this.setState({showModal: false})}/>
                    <Button color="primary" onClick={() => this.setState({showModal: true})}>+ {this.props.t('Lisää organisaatio')}</Button>
                </Grid>
            </PaddedGrid>
        );
    }
}

export default withTranslation()(Organisations);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Organisations.js